"use client"

import { useScaleApplication } from "@/domains/application/use-scale-application"
import { observer } from "mobx-react-lite"
import { Toaster } from "sonner"

const ToasterWrapper = observer(() => {
  const scaleApp = useScaleApplication()
  const notificationPosition = scaleApp?.Settings.notificationPosition

  const offset = ["top-left", "top-right"].includes(notificationPosition) ? 64 : 32
  return (
    <Toaster
      position={notificationPosition ?? "bottom-right"}
      duration={7000}
      offset={offset}
      closeButton={true}
      toastOptions={{}}
    />
  )
})

export default ToasterWrapper
